import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ThemeService } from 'ng2-charts';
import { AppRoutingModule } from 'src/app/app-routing.module';
import { AppComponent } from 'src/app/app.component';
import { HttpConfigInterceptor } from 'src/app/services/interceptor/httpConfigInterceptor';
import { CacheInterceptor } from 'src/app/services/interceptor/cache.interceptor';
import { AuthGuardService } from 'src/app/services/auth-guard.service';
import { AuthServiceService } from 'src/app/services/auth-service.service';
import { AwsAuthService } from 'src/app/services/aws-auth.service';
import { LoaderService } from 'src/app/services/loader/loader.service';
import { SharedDataService } from 'src/app/services/shared-data.service';
import { DialogServiceService } from 'src/app/services/shared/dialog-service.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LoginService } from 'src/app/services/login/login.service';
import { APP_INITIALIZER, ErrorHandler } from "@angular/core";
import { Router } from "@angular/router";
import * as Sentry from "@sentry/angular";
import { LoaderComponent } from 'src/app/shared/loader/loader.component';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';

@NgModule({
    declarations: [
        AppComponent,
        LoaderComponent
    ],
    imports: [
        HttpClientModule,
        AppRoutingModule,
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        CommonModule,
        RouterModule,
        MatProgressSpinnerModule
    ],
    schemas: [NO_ERRORS_SCHEMA],
    providers: [
        LoaderService,
        AuthGuardService,
        AwsAuthService,
        AuthServiceService,
        DialogServiceService,
        SharedDataService,
        ThemeService,
        LoginService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: CacheInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpConfigInterceptor,
            multi: true,
        },

        // Sentry error log:
        {
            provide: ErrorHandler,
            useValue: Sentry.createErrorHandler({
                showDialog: false,
            }),
        },
        {
            provide: Sentry.TraceService,
            deps: [Router],
        },
        {
            provide: APP_INITIALIZER,
            useFactory: () => () => { },
            deps: [Sentry.TraceService],
            multi: true,
        },


    ],
    bootstrap: [AppComponent],
})
export class AppModule {
}
